import Api from 'api';

import {
  GET_NOTIFICATIONS_HISTORIC,
  SET_NOTIFICATIONS_HISTORIC_PAGINATION,
  SET_NOTIFICATIONS_HISTORIC_FILTERS,
  RESET_NOTIFICATIONS_HISTORIC,
  TOGGLE_NOTIFICATION_HISTORIC,
  ADD_NOTIFICATION_HISTORIC,
  UPDATE_NOTIFICATION_HISTORIC,
  GET_NOTIFICATION_HISTORIC_BY_ID,
  RESET_NOTIFICATION_HISTORIC_FORM,
  GET_NOTIFICATION_HISTORIC_FORM_CONFIG,
  MODIFY_EDITING_NOTIFICATION_HISTORIC,
  MODIFY_CUSTOM_FIELD_EDITING_NOTIFICATION_HISTORIC, //Groups
  ADD_CUSTOM_FIELD_EDITING_NOTIFICATION_HISTORIC,
  REMOVE_CUSTOM_FIELD_EDITING_NOTIFICATION_HISTORIC,
  UPDATE_SELF_NOTIFICATION_HISTORIC,
} from 'notifications_historic/constants';

import { SET_LISTS } from 'containers/lists/constants';

export const setPagination = (payload) => ({
  type: SET_NOTIFICATIONS_HISTORIC_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_NOTIFICATIONS_HISTORIC_FILTERS,
  payload,
});

export const getNotificationsHistoric = (
  companyId,
  subcompanyId,
  filters,
  limit,
  page,
  orderBy,
  order
) => ({
  type: GET_NOTIFICATIONS_HISTORIC,
  meta: { needAuth: true },
  payload: Api.notifications_historic.get(
    companyId,
    subcompanyId,
    filters,
    limit,
    page,
    orderBy,
    order
  ),
});

export const reset = () => ({ type: RESET_NOTIFICATIONS_HISTORIC });

export const toggle = (notificationHistoricId, companyId, subcompanyId) => ({
  type: TOGGLE_NOTIFICATION_HISTORIC,
  meta: { id: notificationHistoricId, needAuth: true },
  payload: Api.notifications_historic.toggle(notificationHistoricId, companyId, subcompanyId),
});

export const resetForm = () => ({ type: RESET_NOTIFICATION_HISTORIC_FORM });

export const getNotificationHistoricById = (notificationHistoricId, companyId, subcompanyId) => ({
  type: GET_NOTIFICATION_HISTORIC_BY_ID,
  meta: { needAuth: true },
  payload: Api.notifications_historic.getById(notificationHistoricId, companyId, subcompanyId),
});

export const getFormConfig = (companyId, subcompanyId) => (dispatch) =>
  dispatch({
    type: GET_NOTIFICATION_HISTORIC_FORM_CONFIG,
    meta: { needAuth: true },
    payload: Api.notifications_historic.formConfig(companyId, subcompanyId),
  }).then(({ value: { notification_historic, depreciations } }) => {
    dispatch({
      type: SET_LISTS,
      payload: {
        notification_historic,
        depreciations,
      },
    });
  });

export const modifyNotificationHistoric = (payload) => ({
  type: MODIFY_EDITING_NOTIFICATION_HISTORIC,
  payload,
});

//Groups
export const modifyCustomField = (payload) => ({
  type: MODIFY_CUSTOM_FIELD_EDITING_NOTIFICATION_HISTORIC,
  payload,
}); // Agregado

export const addNotificationHistoric = (companyId, subcompanyId, notificationHistoric) => ({
  type: ADD_NOTIFICATION_HISTORIC,
  payload: Api.notifications_historic.add(companyId, subcompanyId, notificationHistoric),
});

export const updateNotificationHistoric = (
  notificationHistoricId,
  companyId,
  subcompanyId,
  notificationHistoric
) => ({
  type: UPDATE_NOTIFICATION_HISTORIC,
  meta: { id: notificationHistoricId, needAuth: true },
  payload: Api.notifications_historic.update(
    notificationHistoricId,
    companyId,
    subcompanyId,
    notificationHistoric
  ),
});

export const updateSelfNotificationHistoric = (notificationHistoric) => {
  console.log(notificationHistoric);
  // return ({
  // type: UPDATE_SELF_NOTIFICATION_HISTORIC,
  // meta: { needAuth: true },
  // payload: Api.auth.updateInfo(
  //   notificationHistoric
  // )
  //   }
  // )
};

/*
{
	"name": "prueba cambio",
	"lastname": "pruba 2",
	"password":	"admin12345"
}
*/

export const addCustomField = () => ({ type: ADD_CUSTOM_FIELD_EDITING_NOTIFICATION_HISTORIC });

export const removeCustomField = (index) => ({
  type: REMOVE_CUSTOM_FIELD_EDITING_NOTIFICATION_HISTORIC,
  payload: index,
});



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/actions/notifications_historic_actions.js